import {
  GetPropertyDetailsResponseModel,
  PropertyDetailsModel
} from '../../../shared/models/properties/properties.models';
import {createReducer, on} from '@ngrx/store';
import {DefaultStoreState} from '../../models/app-state.model';
import { PropertyDetailsActions } from '../../actions/property/property-details.actions';

export const propertyDetailsKey = 'propertyDetails';

export interface State extends DefaultStoreState {
  details: PropertyDetailsModel;
}

export const initialState: State = {
  details: null,
  isLoading: false,
  error: null,
};

export const reducer = createReducer(
  initialState,
  on(
    PropertyDetailsActions.loadPropertyDetails,
    (state: State) => ({
      ...state,
      isLoading: true
    })
  ),
  on(
    PropertyDetailsActions.loadPropertyDetailsSuccess,
    (state: State, res: GetPropertyDetailsResponseModel) => ({
      ...state,
      details: res.data,
      isLoading: false
    })
  ),
  on(
    PropertyDetailsActions.loadPropertyDetailsFailure,
    (state: State, error) => ({
      ...state,
      error
    })
  ),
);
